// removed by extract-text-webpack-plugin
module.exports = {"CrystalPage":"src-pages-crystal----style-module---CrystalPage---5FdcO","content":"src-pages-crystal----style-module---content---1e4lC","bodyLineHeight":"src-pages-crystal----style-module---bodyLineHeight---2aQn2","thumbnailWrapper":"src-pages-crystal----style-module---thumbnailWrapper---1QK8z","playButton":"src-pages-crystal----style-module---playButton---2vELp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/crystal/style.module.scss
// module id = 63
// module chunks = 35783957827783 222309558401364 241894665707670